<template>
    <div style="height: 100%;">
        <el-table
                :data="formdata"
                 height="100%"

                style="width: 100%;font-size: 20px;"
                :default-sort = "{prop: 'date', order: 'descending'}"
                >

                <el-table-column prop="userName" label="学生名称" fixed ></el-table-column>
                <el-table-column prop="studentNumber" label="家长账号" header-align="center" align="center" ></el-table-column>
                <el-table-column prop="career" label="专业" header-align="center" align="center" ></el-table-column>
                <el-table-column prop="grade" label="年级" header-align="center" align="center" ></el-table-column>
                <el-table-column prop="msg" label="学生学号" header-align="center" align="center" ></el-table-column>
                <el-table-column prop="phone" label="联系电话" header-align="center" align="center" > </el-table-column>
                <el-table-column prop="counselorName" label="所属导员" header-align="center" align="center" > </el-table-column>
                <el-table-column
                  label="密码重置"
                 
                  header-align="center" align="center"
                  >
                  <template slot-scope="scope">          
                    <el-button  size="small" class="butreset" @click="resetpassword(scope.row.userId)">重置</el-button>
                  </template>
                </el-table-column>
    
                <el-table-column
                  
                  label="锁定/解锁"
                  
                   header-align="center" align="center"
                  >
                  <template slot-scope="scope">          
                    <el-button  size="small" class="unlock" @click="lock(scope.row.userId)" v-if="scope.row.ifUse == 1">锁定</el-button>
                    <el-button  size="small" class="lock" @click="lock(scope.row.userId)" v-if="scope.row.ifUse == 0">解锁</el-button>
                  </template>
                </el-table-column>
           <el-table-column
              label="操作"
             fixed="right"
              header-align="center" align="center"
              >
              <template slot-scope="scope">          
                <el-button  size="small" class="butdetele" @click="deteleSelected(scope.row.userId)">删除</el-button>
              </template>
            </el-table-column>
              </el-table>
    </div>
    </template>
    <script>
  export default {
    props:{
        formdata: {
				type: Array,
				default: () => {
					return []
				}
			},
    },
        components: {
    
        },
        data() {
          return { 
          }
          
        },
        methods: {
                      //删除
      deteleSelected(userId){

        console.log(userId,'userId,useeid')
        this.$confirm('是否删除该用户？, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'

        }).then(() => {
            const headers = { 
      'satoken': localStorage.getItem('token') || '' 
    };
    
          this.$http.get(`${this.$config.API_BASE_URL}/hz-university-pc/user/deleteUser`, {
         params: { 
    userId: userId
  },
        headers
      }).then((resp) => {
            let data = resp.data;
            if(data.code == '200') {       						
         this.$message({
            type: 'success',
            message: '删除成功!'
          });
           
// this.$router.go(0); 
// 触发刷新事件
        this.$emit('refresh-data');
              
            } else {
              this.$message.error(data.msg);
    
            }
          }); 


        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
           async lock(userId){
                console.log(userId,'id');
                try {
                  const headers = { 'satoken': localStorage.getItem('token') };
                  const res = await this.$http.get(
                    `${this.$config.API_BASE_URL}/hz-university-pc/user/UseLock`, 
                          {
                  params: { userId }, // GET请求参数要放在params中
                  headers
                }
                  );               
                  if (res.data.code === 200) {
                    this.$emit('refresh-data');
                  }
                } catch (error) {
                  console.error("加载专业数据失败", error);
                }
   
            },
async resetpassword(userId) {
  console.log(userId, 'id');
  
  try {
    // 确认对话框
    await this.$confirm('此操作将重置密码, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });
    
    // 执行重置操作
    const headers = { 
      'satoken': localStorage.getItem('token') || '' 
    };
    
    const res = await this.$http.get(
      `${this.$config.API_BASE_URL}/hz-university-pc/user/resetUserPassWord`, 
      {
        params: { userId },
        headers
      }
    );
    
    if (res.data.code === 200) {
      this.$message({
        message: res.data.msg,
        type: 'success'
      });
    } else {
      this.$message.error(res.data.msg || '重置密码失败');
    }
    
  } catch (error) {
    if (error !== 'cancel') {  // 区分用户取消和真实错误
      console.error("重置密码失败", error);
      this.$message.error('重置密码失败，请稍后重试');
    } else {
      this.$message({
        type: 'info',
        message: '已取消重置密码'
      });
    }
  }
}
          }
      }
      </script>
    <style scoped>
    .lock{
    width: 90px;
    height: 30px;
    opacity: 1;
    border-radius: 5px;
    background: rgba(199, 195, 195, 1);
    
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 1px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    
    
    }
    .butreset{
    
    width: 90px;
    height: 30px;
    opacity: 1;
    border-radius: 5px;
    background: rgba(255, 148, 41, 1);
    line-height: 1px;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0px;
    
    color: rgba(255, 255, 255, 1);
    text-align: center;
    
    
    
    }
    .unlock{
    width: 90px;
    height: 30px;
    opacity: 1;
    border-radius: 5px;
    background: rgba(212, 48, 48, 1);
    line-height: 1px;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0px;
    
    color: rgba(255, 255, 255, 1);
    text-align: center;
    
    }
    .butdetele{
  width: 90px;
height: 30px;
opacity: 1;
border-radius: 5px;
background: rgb(213, 20, 6);
line-height: 1px;
font-size: 18px;
font-weight: 500;
letter-spacing: 0px;

color: rgba(255, 255, 255, 1);
text-align: center;
}
    </style>